import { useEffect, useRef } from 'react'
import Image from 'next/image'
import { STATIC_IMAGE_BASE } from '@mc/constants'

const VIDEO_SRC = `${STATIC_IMAGE_BASE}/gift_hero_video.mp4`
const POSTER_IMG_URL = `${STATIC_IMAGE_BASE}/gift_hero_img.png`

export const Video = ({
  prefersReducedMotion,
}: {
  prefersReducedMotion: boolean
}) => {
  const videoRef = useRef<HTMLVideoElement>(null)
  const posterRef = useRef<HTMLImageElement>(null)

  const opacityTransition = 'Dm2akz'
  const hideClass = 'M8f4yx'

  useEffect(() => {
    const video = videoRef.current
    if (!video) return () => {}

    const onPlaying = () => {
      posterRef.current?.classList.add(hideClass)
    }

    // Safari: Check if video is already playing when useEffect runs
    const HAVE_CURRENT_DATA = 2
    if (!video.paused && !video.ended && video.readyState > HAVE_CURRENT_DATA) {
      onPlaying()
    }

    video?.addEventListener('playing', onPlaying)

    return () => {
      video?.removeEventListener('playing', onPlaying)
    }
  }, [videoRef])

  return (
    <div
      style={{ position: 'relative', width: '100%', height: '100%' }}
      className='mc-mt-md-10'
    >
      <style>
        {`
          .${opacityTransition} { transition: opacity 0.3s ease; }
          .${hideClass} { opacity: 0; pointer-events: none; }
        `}
      </style>
      <Image
        ref={posterRef}
        className={opacityTransition}
        src={POSTER_IMG_URL}
        alt=''
        width={540}
        height={400}
        sizes='(max-width: 768px) 326px, 540px'
        quality={85}
        priority
        loading='eager'
        fetchPriority='high'
        decoding='sync'
        style={{
          width: '100%',
          height: 'auto',
          maxWidth: '100%',
          zIndex: 1,
        }}
      />
      <video
        ref={videoRef}
        preload='none'
        autoPlay={!prefersReducedMotion}
        // eslint-disable-next-line react/no-unknown-property
        fetchpriority='low'
        playsInline
        muted
        loop
        style={{
          width: '100%',
          height: 'auto',
          maxWidth: '100%',
          position: 'absolute',
          top: 0,
          left: 0,
          zIndex: -1,
          opacity: 1,
        }}
      >
        <source src={VIDEO_SRC} type='video/mp4' />
      </video>
    </div>
  )
}
